import { render, staticRenderFns } from "./myClientCell.vue?vue&type=template&id=2e8b5120&scoped=true&"
import script from "./myClientCell.vue?vue&type=script&lang=js&"
export * from "./myClientCell.vue?vue&type=script&lang=js&"
import style0 from "./myClientCell.vue?vue&type=style&index=0&id=2e8b5120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8b5120",
  null
  
)

export default component.exports